import React, { useRef } from 'react'
import { ButtonContainer } from './styled'

const RemoteControlButton = ({ onClick, onLongClick, ...props }) => {
	const singleClickTimeout = useRef()
	const longPressTimeout = useRef()

	const handleMouseDown = e => {
		longPressTimeout.current = setTimeout(() => {
			longPressTimeout.current = true
			if(typeof onLongClick === 'function') {
				onLongClick(e)
			}
		}, 1000)
	}
	const handleMouseUp = e => {
		if(longPressTimeout.current === true) {
			return
		}
		clearTimeout(longPressTimeout.current)
		if (e.detail === 1) {
	    singleClickTimeout.current = setTimeout(() => {
	      if(typeof onClick === 'function') {
					onClick(e)
				}
	    }, 200)
	  }
	}

	return (<ButtonContainer
		onMouseUp={handleMouseUp}
		onMouseDown={handleMouseDown}
		{...props}
	/>)
}

export default RemoteControlButton
